import { render, staticRenderFns } from "./CustomerHistoryValuesTable.vue?vue&type=template&id=227e1bba"
import script from "./CustomerHistoryValuesTable.vue?vue&type=script&lang=js"
export * from "./CustomerHistoryValuesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports